import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BalanceReportIncomePercentModeEnum } from '@zaoblako/shared/modules/finance/enums/balance-report-income-percent-mode.enum';
import { BalanceReportIncomePercentModeEnumI18n } from '@zaoblako/shared/modules/finance/i18n/balance-report-income-percent-mode-enum.i18n';

@Pipe({
  name: 'balanceReportIncomePercentModeName',
  standalone: true
})
export class BalanceReportIncomePercentModeNamePipe implements PipeTransform {
  public transform(mode: BalanceReportIncomePercentModeEnum): string {
    return BalanceReportIncomePercentModeEnumI18n[I18nLocalesEnum.RU_RU][mode] || '';
  }
}
